export const SearchFiled= [
  {
    label:'账号',
    name:'account',
    type:'input',
    prop:{
      placeholder: '请输入账号关键字',
      maxLength:100
    }
  },
  {
    label:'姓名',
    name:'name',
    type:'input',
    prop:{
      placeholder: '请输入账号对应的姓名',
      maxLength:100
    },
  },
  {
    label:'手机号',
    name:'mobiles',
    type:'input',
    prop:{
      placeholder: '请输入账号对应的手机号',
      maxLength:100
    },
  },
  {
    label:'服务商',
    name:'serviceProvider',
    custom:true
  },
]

export const ss=[]
